import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import LocPickerDialog from './LocPickerDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const AccessPointAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
  });

  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);

  const typeOptions = [
    { key: "DOOR",          value: "DOOR" },
    { key: "GATE",          value: "GATE" },
    { key: "TURNSTILE",     value: "TURNSTILE" }
/*
    { key: "ELEVATOR",      value: "ELEVATOR" },
    { key: "BARRIER",       value: "BARRIER" }
*/
  ];

  const protTypeOptions = [
    { key: "PREMISE",       value: "PREMISE" },
    { key: "BUILDING",      value: "BUILDING" },
    { key: "INTERIOR",      value: "INTERIOR" }
/*
    { key: "WING",          value: "WING" }
*/
  ];

  const directionOptions = [
    { key: "ENTRY",         value: "ENTRY" },
    { key: "EXIT",          value: "EXIT" },
    { key: "BIDIRECTIONAL", value: "BIDIRECTIONAL" }
  ];

  const statusOptions = [
    { key: "ONLINE",        value: "ONLINE" },
    { key: "OFFLINE",       value: "OFFLINE" },
    { key: "FAULT",         value: "FAULT" },
    { key: "MAINTENANCE",   value: "MAINTENANCE" }
  ];

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onSensitiveChange = (event) => {
    setObjAttrs({ ...objAttrs, isSensitive: event.target.checked })
  };

  const onDropdownSelect = (target, key) => {

    switch (target) {
      case 'type':
        setObjAttrs({ ...objAttrs, type: key })
        break;
      case 'protType':
        setObjAttrs({ ...objAttrs, protType: key })
        break;
      case 'direction':
        setObjAttrs({ ...objAttrs, direction: key })
        break;
      case 'status':
        setObjAttrs({ ...objAttrs, status: key })
        break;
      default:
        break;
    }
  };

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }

  const handleCreateSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;

    } else if (objAttrs.nameLang2 && (objAttrs.nameLang2.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.nameLang3 && (objAttrs.nameLang3.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;

    } else if (objAttrs.extSysId && (objAttrs.extSysId != null) && objAttrs.extSysId.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + 50);
      return;

/*
    } else if (objAttrs.extSysId2 && (objAttrs.extSysId2 != null) && objAttrs.extSysId2.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id2") + 50);
      return;
*/

    } else if (!objAttrs.type) {
      setErrMsg(t("I18N_ERR_Need_type"));
      return;

    } else if (!objAttrs.protType) {
      setErrMsg(t("I18N_ERR_Need_prot_type"));
      return;

    } else if (!objAttrs.status) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;

    }

    const reqBody = objAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("access-points", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  // Location select dialog stuff

  const handleLocPicker = (e) => {
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {

    // Deep copy
    let newObjAttrs = JSON.parse (JSON.stringify(objAttrs));
    newObjAttrs.locationId = location.id;
    newObjAttrs.location   = location.code;

    setObjAttrs(newObjAttrs);

    setShowLocPickerDialog(false);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_AccessPoint")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_AccessPoint_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col sm={3}>{t("I18N_Code")}: *</Col>
                <Col sm={3}>{t("I18N_Name")}: *</Col>
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang2" value={objAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang3" value={objAttrs.nameLang3}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Type")}: *</Col>
                <Col>{t("I18N_Protection_type")}: *</Col>
                <Col>{t("I18N_Direction")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_label}>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                            onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.type) }
                    onSelect={(key) => onDropdownSelect('type', key)}>
                    {typeOptions.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.protType ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.protType) }
                    onSelect={(key) => onDropdownSelect('protType', key)}>
                    {protTypeOptions.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.direction ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.direction) }
                    onSelect={(key) => onDropdownSelect('direction', key)}>
                    {directionOptions.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Location_code")}:</Col>
            {/* <Col sm={3}>{t("I18N_Asset_code")}:</Col> */}
                <Col sm={3}>{t("I18N_Ext_sys_id")}:</Col>
            {/* <Col sm={3}>{t("I18N_Ext_sys_id2")}:</Col> */}
              </Row>
              <Row className={classes.admin_pages__field_label}>
                <Col sm={3}>
                  <input readOnly className={classes.admin_pages__field_editable} style={{minWidth: '85%'}} name="location" value={objAttrs.location}
                    onChange={(e) => onAttrsInputChange(e)} />
                  <span onClick={handleLocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
{/*
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="assetCode" value={objAttrs.assetCode}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
*/}
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="extSysId" value={objAttrs.extSysId}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
{/*
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="extSysId2" value={objAttrs.extSysId2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
*/}
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Sensitive")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <Form.Check
                    type="switch"
                    id="is-sensitive"
                    checked={objAttrs.isSensitive}
                    onChange={onSensitiveChange}
                  />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Status")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_label}>
                <Col sm={3}>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_ST_" + objAttrs.status) }
                    onSelect={(key) => onDropdownSelect('status', key)}>
                    {statusOptions.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("I18N_ST_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
              </Row>

            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
          <span>{t("I18N_Req_fields")}</span>
        </Row>

        <Row>
          <div display='flex' style={{ marginTop: '15px' }}>
            <Button size="sm" variant="outline-secondary" className="mb-3"
              style={{ float: 'left' }}
              onClick={handleCreateCancel}>
              {t("I18N_Cancel")}
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-3"
              style={{ marginLeft: '15px' }}
              onClick={handleCreateSubmit}>
              {t("I18N_Submit")}
            </Button>
            <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {errMsg}
            </span>
          </div>
        </Row>

        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

      </Card>
    </>
  );
}

export default AccessPointAdminNewView;
